import { Link } from "@tanstack/react-router";

const variants = {
  default: {
    icon: "text-emerald-deep",
    lotus: "text-emerald-deep",
    flow: "text-gold-deep",
    tagline: "text-emerald-deep/90",
  },
  light: {
    icon: "text-gold",
    lotus: "text-perl",
    flow: "text-gold",
    tagline: "text-perl/70",
  },
};

/**
 * lotus flow wordmark — five-petal lotus glyph + serif wordmark
 * matching lotus-flow.de. Supports a light variant for dark backgrounds.
 */
export function Logo({
  className = "",
  tagline = "Maharani Singh",
  variant = "default",
}: {
  className?: string;
  tagline?: string;
  variant?: "default" | "light";
}) {
  const v = variants[variant];

  return (
    <Link
      to="/"
      className={`group flex items-center gap-3 ${className}`}
      aria-label="lotus flow – Maharani Singh – Startseite"
    >
      <svg
        viewBox="0 0 48 48"
        aria-hidden="true"
        fill="none"
        className={`size-11 transition-transform duration-500 ease-out group-hover:-rotate-6 ${v.icon}`}
      >
        <g
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {/* center petal */}
          <path d="M24 34 C19 25 20 14 24 8 C28 14 29 25 24 34 Z" />
          {/* inner left/right petals */}
          <path d="M24 34 C16 28 13 18 13 11 C20 14 25 22 24 34 Z" />
          <path d="M24 34 C32 28 35 18 35 11 C28 14 23 22 24 34 Z" />
          {/* outer left/right petals */}
          <path d="M24 34 C9 30 6 22 5 16 C13 16 22 24 24 34 Z" />
          <path d="M24 34 C39 30 42 22 43 16 C35 16 26 24 24 34 Z" />
          {/* water cradle */}
          <path d="M11 34 C17 39 31 39 37 34" />
        </g>
      </svg>
      <span className="flex flex-col leading-none">
        <span className={`font-display text-[1.55rem] tracking-tight ${v.lotus}`}>
          lotus <span className={`italic ${v.flow}`}>flow</span>
        </span>
        <span className={`mt-1 text-[0.62rem] font-semibold uppercase tracking-[0.28em] ${v.tagline}`}>
          {tagline}
        </span>
      </span>
    </Link>
  );
}
